import FormInputGroup from './formInputGroup-TEMPLATE_VERSION'

export default FormInputGroup
